import styled, {css} from 'styled-components'
import {Button} from '@components/ui/button/Button.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledExportButton = styled(Button)`
    flex-shrink: 0;
`

export const StyledTicketPageHeaderContainer = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: 1fr auto;
`
export const StyledTicketPageHeaderWrapper = styled(Flexbox)`
    ${({theme: {spacing}}) => css`
        padding-top: ${spacing * 10}px;
    `}
`

export const StyleTabSection = styled.div`
    ${({theme: {palette}}) => css`
        border-bottom: 1px solid ${palette.neutral['300']};
    `}
`
